export default __webpack_public_path__ + "static/media/prd_vegi.744130c4.png";